/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/1/14
 * Time: 4:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Template = require("personalization-templates/menuView.tmpl");
    var CONST = require("const");

    var EditView;


    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        EditView = Marionette.CompositeView.extend({
            template: Template,
            withUIComponents: true,
            ui:{
                personalizationMenu : ".personalization-edit-feature"
            },
            initialize: function (options) {
                this.viewsMap = options.viewsMap;
            },
            onRender: function () {

            },
            onClose: function () {
                var i = 0;
            },
            buildItemView: function(item, ItemViewType, itemViewOptions){
                var featureId = item.get("featureId");
                return this.viewsMap[featureId];
            }



        });
    });
    return EditView;

});

